import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Card,
  CardContent,
} from "@mui/material";

const CookiesPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ padding: "2rem 1rem" }}>
    <Typography
      variant="h4"
      component="h1"
      gutterBottom
      align="center"
      sx={{ color: "#fff",fontWeight: 900 }}
    >
      Cookie Policy
    </Typography>
  
    <Card
      sx={{
        marginBottom: "1.5rem",
        backgroundColor: "#B6BFE04D",
        color: "#fff",
        border: "2px solid #B6BFE080",
      }}
    >
      <CardContent>
        <Typography variant="body1" sx={{ color: "#fff" }}>
          Background
          <br />
          This website <strong> europasolutions.co.uk</strong> (“Our Site”) uses cookies and similar technologies in order to distinguish you from other users. By using cookies, we are able to provide you with a better experience and to improve our Site by better understanding how you use it. Please read this Cookie Policy carefully and ensure that you understand it. Your acceptance of our Cookie Policy is deemed to occur if you continue using our Site. If you do not agree to our Cookie Policy, please stop using our Site immediately.
        </Typography>
      </CardContent>
    </Card>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">1. Definitions and Interpretation</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ color: "#000", backgroundColor: "#B6BFE04D" }}>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "5px" }}><strong>Cookie:</strong> Means a small file placed on your computer or device by Our Site when you visit certain parts of Our Site and/or when you use certain features of Our Site.</li>
          <li style={{ marginBottom: "5px" }}><strong>Cookie Law:</strong> Means the relevant parts of the Privacy and Electronic Communications (EC Directive) Regulations 2003 and the UK GDPR.</li>
          <li style={{ marginBottom: "5px" }}><strong>Personal Data:</strong> Means any and all data that relates to an identifiable person who can be directly or indirectly identified from that data, as defined by the UK GDPR and the Data Protection Act 2018.</li>
          <li style={{ marginBottom: "5px" }}><strong>We/Us/Our:</strong> Means <strong>Europa Solutions Limited</strong>, a limited company registered in England under company number <strong>07827816</strong>, whose registered office is located at <strong>18 Lincoln Drive, Houlton, Rugby, England, CV23 1BS</strong>.</li>
        </ul>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">2. Information About Us</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px" }}>
         <strong>2.1:</strong> Our Site is owned and operated by<strong> Europa Solutions Limited</strong>, a private limited company registered in England under company number <strong>07827816</strong>, whose registered office is located at <strong>18 Lincoln Drive, Houlton, Rugby, England, CV23 1BS</strong>.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">3. How Does Our Site Use Cookies?</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px"}}>
        <strong>3.1:</strong> Our Site may place and access certain first-party cookies on your computer or device. First-party cookies are those placed directly by Us and are used only by Us. We use cookies to facilitate and improve your experience of Our Site.
        </Typography>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px"}}>
        <strong>3.2:</strong> By using Our Site, you may also receive certain third-party cookies on your computer or device. These cookies may be used for services like analytics or advertising.
        </Typography>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px"}}>
        <strong>3.3:</strong> We may use some or all of the following types of cookies:
        </Typography>
        <ul style={{color:"#000", listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "5px" }}><strong>Strictly Necessary Cookies -</strong> These are essential for the operation of our website, such as remembering your preferences</li>
          <li style={{ marginBottom: "5px" }}><strong>Analytics Cookies -</strong> These help us understand how you use Our Site and improve the experience (e.g., Google Analytics).</li>
          <li style={{ marginBottom: "5px" }}><strong>Functionality Cookies -</strong> These allow us to provide additional features like remembering your preferences or personalizing your experience.</li>
          <li style={{ marginBottom: "5px" }}><strong>Targeting Cookies -</strong> These allow us to display relevant advertisements based on your usage.</li>
        </ul>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">4. What Cookies Does Our Site Use?</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px" }}>
          <strong>4.1 First-Party Cookies:</strong>
        </Typography>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px" }}>
          These cookies are placed directly by us to enhance your experience on our site.
        </Typography>
        <ul style={{color:"#000", listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "5px" }}><strong>_ga:</strong> Used to distinguish users in Google Analytics (Not strictly necessary).</li>
          <li style={{ marginBottom: "5px" }}><strong>_gid:</strong> Used to identify users for a 24-hour period in Google Analytics (Not strictly necessary).</li>
        </ul>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px" }}>
          <strong>4.2 Third-Party Cookies:</strong>
        </Typography>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px" }}>
           These cookies are placed by external services to help us with advertising and analytics.
        </Typography>
        <ul style={{color:"#000", listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "5px" }}><strong>_fbp:</strong> Used for Facebook advertising services (Not strictly necessary).</li>
          <li style={{ marginBottom: "5px" }}><strong>_gcl_au:</strong> Used for Google AdSense advertising services (Not strictly necessary).</li>
        </ul>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">5. Consent and Control</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px"}}>
        <strong>5.1:</strong> Before cookies are placed on your computer or device, you will be shown a prompt requesting your consent to set those cookies. By giving your consent, you are enabling us to provide the best possible experience and service to you. You may deny consent to the placing of cookies (except for strictly necessary cookies); however, certain features of our site may not function fully.
        </Typography>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px"}}>
        <strong>5.2:</strong> In addition to the controls we provide, you can also manage cookies directly in your browser settings.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">6. Changes to this Cookie Policy</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px"}}>
        <strong>6.1:</strong> We may alter this Cookie Policy at any time. Any such changes will become binding on you upon your first use of Our Site after the changes have been made. Please check this page periodically for any updates.
        </Typography>
      </AccordionDetails>
    </Accordion>
  
    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">7. Further Information</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "#B6BFE04D" }}>
        <Typography variant="body1" sx={{ color: "#000",marginBottom: "5px"}}>
        <strong>7.1:</strong> If you would like to know more about how We use cookies, please contact Us at <a href="mailto:info@europasolutions.co.uk"><strong>info@europasolutions.co.uk</strong></a>, or by post at <strong>18 Lincoln Drive, Houlton, Rugby, England, CV23 1BS</strong>.
        </Typography>
      </AccordionDetails>
    </Accordion>

    <Accordion
      sx={{
        marginBottom: "1rem",
        border: "1px solid transparent",
        color: "#fff",
        borderRadius: "4px",
        overflow: "hidden",
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
        sx={{
          background: "linear-gradient(90deg, #2D30AB, #9D3DBA)",
          color: "#fff !important",
          transition: "background 0.3s ease",
          "&:hover": {
            background: "linear-gradient(90deg, #9D3DBA, #2D30AB)",
          },
        }}
      >
        <Typography color="#fff">Attribution</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ backgroundColor: "#B6BFE04D",marginBottom: "5px" }}>
        <Typography variant="body1" sx={{ color: "#000",}}>
        This Cookie Policy was last updated on <strong>1st April 2025</strong>.
        </Typography>
      </AccordionDetails>
    </Accordion>
  </Container>
  
  );
};

export default CookiesPolicy;
